import { render } from "./TabWrapper.vue?vue&type=template&id=ef6fd17e&scoped=true"
import script from "./TabWrapper.vue?vue&type=script&lang=js"
export * from "./TabWrapper.vue?vue&type=script&lang=js"

import "./TabWrapper.vue?vue&type=style&index=0&id=ef6fd17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6fd17e"]])

export default __exports__